export const Footer = () => (
  <footer className="bg-[#0A2647]">
    <div className="mx-auto flex max-w-6xl flex-col items-center gap-4 px-6 py-10 text-center md:flex-row md:justify-between md:text-left">
      <div className="flex items-center gap-3">
        <span className="block h-9 w-9 overflow-hidden rounded-full ring-1 ring-white/30">
          <img
            src="/logo.png"
            alt=""
            loading="lazy"
            className="h-full w-full scale-[2.9] object-cover object-[49%_49%]"
          />
        </span>
        <div>
          <p className="font-display text-sm font-semibold tracking-[0.14em] text-white">
            VAL-HUE HIGH SCHOOL &amp; JUNIOR COLLEGE
          </p>
          <p className="mt-1 text-[11px] text-[#D6EBEE]/60">
            Manjari Budruk, Pune 412307 · Since 2002
          </p>
        </div>
      </div>
      <p className="text-[11px] text-[#D6EBEE]/50">
        © 2026 Val-Hue High School &amp; Junior College
      </p>
    </div>
  </footer>
);
